var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 按丟失保價金額賠償 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }